import Cookies from "js-cookie";

if (!Cookies.get("goodtravel_newsletter")) {
  setTimeout(function () {
    $("#newsletter_modal").prop("checked", true).trigger("change");
  }, 30000);
}

$(document).on("change", "#newsletter_modal", function () {
  if (!$(this).is(":checked")) {
    Cookies.set("goodtravel_newsletter", { accepted: false }, { expires: 365 });
  }
});

$(document).keyup(function (e) {
  if (e.which == 27) {
    $("#newsletter_modal").prop("checked", false).trigger("change");
  }
});

$(document).on("click", ".modal > .button", function () {
  Cookies.set("goodtravel_newsletter", { accepted: true }, { expires: 365 });
});
